/** Values accepted by navo_api `EProductStatus` (dev branch). */
export const PRODUCT_STATUS = {
  IN_STOCK: "in_stock",
  OUT_OF_STOCK: "out_of_stock",
} as const;

export type ProductStatusValue =
  (typeof PRODUCT_STATUS)[keyof typeof PRODUCT_STATUS];

export const PRODUCT_STATUS_OPTIONS: {
  value: ProductStatusValue;
  label: string;
}[] = [
  { value: PRODUCT_STATUS.IN_STOCK, label: "In Stock" },
  { value: PRODUCT_STATUS.OUT_OF_STOCK, label: "Out of Stock" },
];

const LABELS: Record<string, string> = {
  in_stock: "In Stock",
  out_of_stock: "Out of Stock",
  IN_STOCK: "In Stock",
  OUT_OF_STOCK: "Out of Stock",
  DISABLED: "Disabled",
};

export function formatProductStatus(status: string | null | undefined): string {
  if (!status) return "N/A";
  return LABELS[status] ?? status.replace(/_/g, " ");
}

/** Map legacy UI/DB values to API enum where possible. */
export function normalizeProductStatusForApi(
  status: string,
): ProductStatusValue | string {
  const legacy: Record<string, ProductStatusValue> = {
    IN_STOCK: PRODUCT_STATUS.IN_STOCK,
    OUT_OF_STOCK: PRODUCT_STATUS.OUT_OF_STOCK,
    DISABLED: PRODUCT_STATUS.OUT_OF_STOCK,
  };
  return legacy[status] ?? status;
}
